/**
 * The server's /healthz, shared under one cache key (docs/07: environment
 * behavior is driven by APP_ENV, never by hostname). The shell's TEST banner,
 * the env pill and the Dev-only QA panel (L-36) all follow it.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { api, type Health } from './api.js';

export function useHealth(): UseQueryResult<Health> {
  return useQuery({
    queryKey: ['healthz'],
    queryFn: () => api<Health>('/healthz'),
    staleTime: Infinity,
  });
}

/** True only once the server has said it is the test environment. */
export function useIsTestEnv(): boolean {
  return useHealth().data?.env === 'test';
}
